/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:52:13
 * @LastEditTime: 2023-11-14 14:03:46
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\modules\earlyWarningStatisRouter.js
 * 预警统计路由
 */
import store from '@/store'
import { getAuthClientList } from '@/api/common'
const earlyWarningStatisRouter = [
  // 预警/流失客户
  {
    path: '/flowSystem/customer-early-warning-statistics',
    name: 'flowSystemStatisticsCustomerEarlyWarning',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/CustomerEarlyWarning.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/lost-customers/Page.vue'
      ), //新迁移文件
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      title: '预警/流失客户'
    }
  },
  // 商业购进异常预警
  {
    path: '/flowSystem/sygj-warning-page',
    name: 'flowSystemAbnormalCommercialPurchaseWrning',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/abnormal-commercial-purchase-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计',
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        }
      ],
      title: '商业购进异常预警'
    }
  },
  // 商业购进异常预警  商业购进数据明&&销售数据明细
  {
    path: '/flowSystem/sygj-warning-page/sales-data-detail/:json',
    name: 'flowSystemSalesDataDetail',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/abnormal-commercial-purchase-warning/SalesDataDetail.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计',
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        },
        {
          title: '商业购进异常预警',
          name: 'flowSystemAbnormalCommercialPurchaseWrning'
        }
      ],
      title: ''
    }
  },
  // 批号缺失预警
  {
    path: '/flowSystem/phqs-warning-page',
    name: 'flowSystemBatchNumberMissingWarning',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/batch-number-missing-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        }
      ],
      title: '批号缺失预警'
    }
  },

  // 批号缺失预警  销售数据明细
  {
    path: '/flowSystem/phqs-warning-page/sales-data-detail/:json',
    name: 'flowSystemPhqsSalesDataDetail',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/batch-number-missing-warning/SalesDataDetail.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计',
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        },
        {
          title: '批号缺失预警',
          name: 'flowSystemBatchNumberMissingWarning'
        }
      ],
      title: '销售数据明细'
    }
  },

  // 进货频次异常客户
  {
    path: '/flowSystem/frequency-of-purchase-statistics',
    name: 'flowSystemStatisticsFrequencyOfPurchase',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/FrequencyOfPurchase.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/abnormal-customers/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      title: '进货频次异常客户'
    }
  },
  // 销售异常数据
  {
    path: '/flowSystem/abnormal-purchase-statistics',
    name: 'flowSystemStatisticsAbnormalPurchase',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/AbnormalPurchase.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/abnormal-data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      title: '销售异常数据'
    }
  },

  

  // 窜货预警
  {
    path: '/flowSystem/ch-warning-page',
    name: 'flowSystemChWarningPage',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/ch-warning-page/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        }
      ],
      title: '窜货预警'
    }
  },

  {
    path: '/flowSystem/syxsph-warning-page',
    name: 'flowSystemSyxsphWarningPage',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/syxsph-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        }
      ],
      title: '商业销售/批号预警'
    }
  },

  
  // 商业窜货分析
  {
    path: '/flowSystem/commercial-fleeing-goods-warning',
    name: 'commercialFleeingGoodsWarning',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/commercial-fleeing-goods-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      title: '商业窜货分析'
    }
  },
  // 商业销售/批号预警
  {
    path: '/flowSystem/syxsph-warning-page',
    name: 'flowSystemSyxsphWarningPage',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/syxsph-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      breadcrumb: [
        {
          title: '预警统计',
          name: ''
        }
      ],
      title: '商业销售/批号预警'
    }
  },
  // 商业窜货分析
  {
    path: '/flowSystem/commercial-fleeing-goods-warning',
    name: 'commercialFleeingGoodsWarning',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/commercial-fleeing-goods-warning/Page.vue'
      ),
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      title: '商业窜货分析'
    }
  },

  // 库存效期预警
  {
    path: '/flowSystem/stock-expiry-warning',
    name: 'flowSystemStockExpiryWarning',
    component: () =>
      import(
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/early-warning-statis/stock-expiry-warning/Page.vue'
      ),  
    meta: {
      SecondaryMenu: '预警统计', //二级菜单
      title: '库存效期预警',
    },
  },

]
export default earlyWarningStatisRouter
